import React, { Dispatch, SetStateAction } from 'react';

import PolygonDraw from '@/components/Map/shared/PolygonDraw';

interface Props {
  polygons: google.maps.LatLngLiteral[][];
  setPolygons: (polygons: google.maps.LatLngLiteral[][]) => void;
  drawing: boolean;
  points: google.maps.LatLngLiteral[];
  setPoints: Dispatch<SetStateAction<google.maps.LatLngLiteral[]>>;
}

function Drawing({
  polygons,
  setPolygons,
  drawing,
  points,
  setPoints,
}: Props): React.ReactElement {
  return (
    <PolygonDraw
      active={drawing}
      points={points}
      setPoints={setPoints}
      onComplete={completed => setPolygons([...polygons, completed])}
    />
  );
}

export default Drawing;
